import keyBy from 'lodash/keyBy';
import { DataSyncObjectStatusEnum } from 'appConsts';

import { getDataSyncStatus } from '../DataService';
import User from '../../currentUser';

const user = new User();

export default async function getDSOsWithRemoteStatus(DSOs) {
  const dataSyncInfo = DSOs.map(dso => ({ dataSyncId: dso.id, userId: dso.userId || user.id() }));
  const dataSyncStatuses = await getDataSyncStatus(dataSyncInfo);

  const dataSyncStatusById = keyBy(dataSyncStatuses, 'dataSyncId');

  const succeededDSOs = [];
  const versionMismatchErrorDSOs = [];
  const otherErrorDSOs = [];
  const notReceivedDSOs = [];

  DSOs.forEach((dso) => {
    const dsoId = dso.id;
    const status = dataSyncStatusById[dsoId];
    if (!status) {
      notReceivedDSOs.push({ ...dso, dataSyncStatus: status });
      return;
    }

    switch (status.status) {
      case DataSyncObjectStatusEnum.success:
        succeededDSOs.push({ ...dso, dataSyncStatus: status });
        break;
      case DataSyncObjectStatusEnum.error: {
        const message = status.message;
        if (message.includes('VERSION_MISMATCH')) {
          versionMismatchErrorDSOs.push({ ...dso, dataSyncStatus: status });
        } else {
          otherErrorDSOs.push({ ...dso, dataSyncStatus: status });
        }
        break;
      }
      case DataSyncObjectStatusEnum.notReceived:
        notReceivedDSOs.push({ ...dso, dataSyncStatus: status });
        break;
      default:
        break;
    }
  });

  return {
    succeededDSOs,
    versionMismatchErrorDSOs,
    otherErrorDSOs,
    notReceivedDSOs
  };
}
